
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 4h16v16H4V4zM2 22V2h20v20H2zm6.636-5.364l8-8-1.272-1.272-8 8 1.272 1.272zM9 9.6a.6.6 0 100-1.2.6.6 0 000 1.2zM9 11a2 2 0 100-4 2 2 0 000 4zm6.6 4a.6.6 0 11-1.2 0 .6.6 0 011.2 0zm1.4 0a2 2 0 11-4 0 2 2 0 014 0z","fill":"#2A333D"}})])
          )
        }
      }
    